// extracted by mini-css-extract-plugin
export default {"main":"PrivacyPolicy_main__-XuYd"};